
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import ElementUI from 'element-ui';

import '@/assets/scss/element-variables.scss';
// import '@/assets/css/fontawesome-free-5.15.4-web/css/all.css';
import App from './App'
import router from './router'
import Axios from 'axios'
import Vuelidate from 'vuelidate'
import locale from 'element-ui/lib/locale/lang/en'
import VueMoment from 'vue-moment'
import moment from 'moment'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Config from "./config/config";

import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import VueGraph from 'vue-graph'

import multiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import browserDetect from "vue-browser-detect-plugin";
import JwPagination from 'jw-vue-pagination';
import VueSocketIO from 'vue-socket.io';

Vue.component('jw-pagination', JwPagination);
Vue.use(browserDetect);
Vue.component('multiselect', multiSelect);

/*

    mj@2019.03.15.1022

    +-------------+
    | Import scss |
    +-------------+

 */

import '@/assets/scss/general.scss';
import '@/assets/scss/sections.scss';
import '@/assets/scss/elements.scss';
import '@/assets/scss/aniButton.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/main.scss';


Vue.use(VueGraph);
Vue.use(Vuelidate);
Vue.use(Vuesax);
Vue.use(VueMoment);
Vue.use(ElementUI, {size: "Medium", locale});
Vue.use(BootstrapVue);
Vue.mixin({
    methods: {
        fncLog(message) {
        },
        fncGotoPage(strPageName) {

            this.$router.push({name: strPageName});
        },
    }
})

// Setup Axios interceptors
Axios.interceptors.response.use(
  response => {
    // If response is successful, just return it
    return response;
  },
  error => {
    // Handle errors globally
    if (error.response) {
      // Server responded with a status code outside 2xx
      console.error('HTTP Error Response:', {
        url: error.config.url,
        status: error.response.status,
        data: error.response.data
      });

      if (error.response.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace("#/login");
      }

    }
    // Reject to allow local .catch() handling if needed
    return Promise.reject(error);
  }
);

Vue.prototype.$http = Axios;
Vue.prototype.moment = moment;

Vue.prototype.$localApiURL = Config.localApiURL;
Vue.prototype.$publicApiURL = Config.publicApiURL;

if ( Config.IS_WEBSOCKETS ) {

  console.log('Websockets are enabled');

  if (Config.webSocketsUrl) {
    Vue.use(new VueSocketIO({
      debug: !!Config.isDev,
      connection: Config.webSocketsUrl
    }))
  }

} else {
  console.log('Websockets are disabled');
}

Vue.config.productionTip = false;
window.Event = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  mounted: function() {
    console.log("APP HAS MOUNTED");
  }
});

console.log("%cApp Version " + Config.APP_VERSION, "color:#ff932d; font-weight: bold;");






// WEBPACK FOOTER //
// ./src/main.js